/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, Typography2 } from '@coursera/cds-core';

import DottedSeparator from 'bundles/unified-description-page-common/components/shared/DottedSeparator';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  title: css`
    margin-bottom: var(--cds-spacing-100);
  `,
  skillItem: css`
    display: flex;
    align-items: flex-start;
    gap: 0;
    margin-bottom: var(--cds-spacing-50);
  `,
  skillText: css`
    flex: 1;
    margin: 0;
  `,
  dottedSeparator: css`
    position: relative;
    bottom: 2px;
  `,
};

type Props = {
  skillExpressions: string[];
};

const SkillPathwayCourseContent = ({ skillExpressions }: Props) => {
  if (skillExpressions.length === 0) {
    return null;
  }

  const midpoint = Math.ceil(skillExpressions.length / 2);
  const firstHalf = skillExpressions.slice(0, midpoint);
  const secondHalf = skillExpressions.slice(midpoint);

  return (
    <div>
      <Typography2 variant="subtitleMedium" component="h2" css={styles.title}>
        {_t("Skills you'll master")}
      </Typography2>
      <Grid container spacing={24}>
        <Grid item xs={12} md={6}>
          {firstHalf.map((skillExpression) => (
            <div css={styles.skillItem} key={skillExpression}>
              <div css={styles.dottedSeparator}>
                <DottedSeparator />
              </div>
              <Typography2 variant="bodySecondary" component="p" color="supportText" css={styles.skillText}>
                {skillExpression}
              </Typography2>
            </div>
          ))}
        </Grid>
        <Grid item xs={12} md={6}>
          {secondHalf.map((skillExpression) => (
            <div css={styles.skillItem} key={skillExpression}>
              <div css={styles.dottedSeparator}>
                <DottedSeparator />
              </div>
              <Typography2 variant="bodySecondary" component="p" color="supportText" css={styles.skillText}>
                {skillExpression}
              </Typography2>
            </div>
          ))}
        </Grid>
      </Grid>
    </div>
  );
};

export default SkillPathwayCourseContent;
